import React, { useState } from "react";
import MapsUgcOutlinedIcon from "@mui/icons-material/MapsUgcOutlined";
import HistoryIcon from "@mui/icons-material/History";
import { Box, Fab } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import MessageDialog from "../Login/MessageDialog";
import MTextField from "../MTextField";
import MAutocomplete from "../MSelect";
import { useComments } from "../../../lib/servicesGenericsTables/useComments";
import useAuth from "../../context/AuthContext";
import CustomDataGrid from "../CustomDataGrid";
import { columnsComments } from "../../pages/samples/utils/columnsComments";
import { Loading } from "../Loading";
import { CommentsSaveTypes } from "../../pages/user/Samples/SampleProcessing/utils/comments.types";

interface CommentsType {
  id: string;
  label: string;
}

interface CommentsButtonsProps {
  idSample: number;
}

const commetsTypes: CommentsType[] = [
  { id: "Interno", label: "Interno" },
  { id: "Externo", label: "A informes" },
];

const CommentsButtons = ({ idSample }: CommentsButtonsProps) => {
  const { save, commentsList, loading, fetchSample } = useComments();
  const { user } = useAuth();

  const [dialogData, setDialogData] = useState({
    active: false,
    needChildren: true,
    component: "Confirm",
    size: "lg",
  });
  const [historyDialogActive, setHistoryDialogActive] = useState(false);

  const methods = useForm({
    defaultValues: {
      type_comment: { id: "Interno", label: "Interno" },
      comment: "",
    },
  });

  const handleOpenDialog = () => {
    setDialogData({ ...dialogData, active: true });
  };

  const handleCloseDialog = () => {
    setDialogData({ ...dialogData, active: false });
  };

  const handleSaveComment = async (data: any) => {
    const payload: CommentsSaveTypes = {
      analyst: user?.id as number,
      comment: data.comment,
      date_time: new Date().toISOString(),
      internal: data.type_comment.id === "Interno" ? 1 : 0,
      sample_registration: idSample,
    };
    await save(payload);
    methods.reset();
    handleCloseDialog();
  };

  const handleOpenHistory = () => {
    setHistoryDialogActive(true);
    fetchSample(idSample);
  };

  const handleCloseHistory = () => {
    setHistoryDialogActive(false);
  };

  return (
    <>
      <Fab
        size="small"
        color="secondary"
        aria-label="edit"
        title="Nuevo comentario"
        style={{
          position: "fixed",
          top: "50%",
          right: 16,
          zIndex: 1000,
        }}
        onClick={handleOpenDialog}
      >
        <MapsUgcOutlinedIcon />
      </Fab>

      <Fab
        size="small"
        color="primary"
        aria-label="history"
        title="Mostrar historial"
        style={{
          position: "fixed",
          top: "56%",
          right: 16,
          zIndex: 1000,
        }}
        onClick={handleOpenHistory}
      >
        <HistoryIcon />
      </Fab>

      <MessageDialog
        data={{
          active: historyDialogActive,
          size: "lg",
          component: "Save",
          title: "Historial de Comentarios",
        }}
        handleClose={handleCloseHistory}
      >
        {loading ? (
          <Loading />
        ) : (
          <Box p={4}>
            <CustomDataGrid
              rows={commentsList}
              columns={columnsComments}
              search={false}
            />
          </Box>
        )}
      </MessageDialog>

      <MessageDialog
        data={{
          ...dialogData,
          title: "Agregar Comentario",
          size: "sm",
        }}
        handleClose={handleCloseDialog}
        handleConfirm={methods.handleSubmit(handleSaveComment) as any}
      >
        {dialogData.needChildren && (
          <FormProvider {...methods}>
            <form style={{ padding: 16 }}>
              <MAutocomplete
                key="type_comment"
                name="type_comment"
                options={commetsTypes}
                label="Seleccione un tipo de comentario"
                getOptionLabel={(option) => option.label}
                validation={{ required: "El tipo de comentario es requerido" }}
              />

              <MTextField
                key="comment"
                name="comment"
                label="Comentario"
                placeholder="Comentario"
                type="textArea"
                rows={4}
                multiline
                fullWidth
                validation={{ required: "El comentario es requerido" }}
                style={{ marginTop: 16 }}
                inputProps={{ maxLength: 400 }}
              />
            </form>
          </FormProvider>
        )}
      </MessageDialog>
    </>
  );
};

export default CommentsButtons;
